





























import { Prop, Component, Vue } from 'vue-property-decorator';
import  DialogForm from '../Form/DialogForm.vue';

@Component({
  components:{
    DialogForm
  }
})
export default class Confirm extends Vue {
  @Prop(Boolean) 
  value: boolean;

  @Prop(Number) 
  overlayOffset: number;

  @Prop(Object) 
  target: any;

}
